export default __webpack_public_path__ + "static/media/Circle1.5882e496.svg";